<template>
  <layout-bottom-sheet ref="bottomSheet" bottomSheetClass="forgot-pass-bs">
    <template v-slot:header>
      <div class="title" @click="close">
        <atomic-icon id="arrow_previous" />
        {{ getContent(popupsData, defaultLocalePopupsData, 'authorization.resetPassword') }}
      </div>
    </template>

    <modal-content-forgot-pass
      ref="forgotPassForm"
      v-model:isProcessing="isProcessing"
      v-model:selectedTab="selectedTab"
      @validate="submitForm"
      @phoneValidated="emit('phoneValidated', $event)"
      @emailSent="emit('emailSent', $event)"
    />

    <template v-slot:footer>
      <button-base type="primary" size="md" :isProcessing="isProcessing" @click="submitForm">
        {{ getContent(layoutData, defaultLocaleLayoutData, 'buttons.send') }}
      </button-base>
    </template>
  </layout-bottom-sheet>
</template>

<script setup lang="ts">
  import type { IBottomSheetComponent } from '@skeleton/core/types';

  const { getContent } = useProjectMethods();

  const {
    layoutData,
    defaultLocaleLayoutData,
    popupsData,
    defaultLocalePopupsData,
  } = storeToRefs(useGlobalStore());

  const forgotPassForm = ref(null);
  const selectedTab = ref('email');
  const isProcessing = ref(false);
  const bottomSheet = ref<Maybe<IBottomSheetComponent>>();

  const emit = defineEmits([
    'phoneValidated',
    'emailSent',
  ]);

  const submitForm = () => {
    forgotPassForm.value?.validateForm();
  };

  const close = (): void => {
    bottomSheet.value!.close();
  };

  const open = async (): void => {
    await bottomSheet.value!.open();
  };

  defineExpose({
    open,
    close,
  });
</script>

<style src="~/assets/styles/components/bottom-sheet/forgot-pass.scss" lang="scss" />
